import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ChevronRight from "@mui/icons-material/ChevronRight";
//Limitless imports
import { withi18n } from "../../../../customer/components";
const NavigtaionItem = ({
  onClickHandle,
  link,
  classes,
  t,
  text,
  icon,
  selected,
  id,
  listItemStyles
}) => {
  const handleClick = event => {
    onClickHandle(link, event);
  };
  return /*#__PURE__*/React.createElement(ListItem, {
    button: true,
    onClick: handleClick,
    className: `${selected ? classes.selectedBackground : ""} ${classes.navItem} ${listItemStyles}`,
    id: `navigationItemButton${id}`
  }, /*#__PURE__*/React.createElement(ListItemIcon, {
    classes: {
      root: classes.icon
    },
    className: `${selected ? classes.selectedTextColor : ""}`
  }, icon), /*#__PURE__*/React.createElement(ListItemText, {
    primary: /*#__PURE__*/React.createElement(Typography, {
      component: "span",
      id: text,
      className: classes.navItemFont
    }, t(text)),
    className: `${selected ? classes.selectedTextColor : ""}`,
    classes: {
      root: classes.navItemPadding
    }
  }), /*#__PURE__*/React.createElement(ListItemIcon, {
    className: `${selected ? classes.selectedTextColor : ""}`,
    classes: {
      root: classes.rightIcon
    }
  }, /*#__PURE__*/React.createElement(ChevronRight, {
    className: `${selected ? classes.selectedTextColor : ""}`
  })));
};
const styles = theme => {
  var _theme$palette$dialog, _theme$palette$dialog2, _theme$palette$dialog3, _theme$palette$dialog4, _theme$palette$dialog5, _theme$palette$dialog6;
  return {
    navItem: {
      paddingRight: 5,
      paddingLeft: 16
    },
    icon: {
      marginRight: 10,
      color: theme.palette.primary.dark,
      opacity: 0.8
    },
    navItemPadding: {
      padding: "0 10px"
    },
    rightIcon: {
      marginRight: 0,
      color: theme.palette.primary.dark,
      opacity: 0.8
    },
    selectedBackground: {
      backgroundColor: (_theme$palette$dialog = theme.palette.dialogues) === null || _theme$palette$dialog === void 0 ? void 0 : (_theme$palette$dialog2 = _theme$palette$dialog.expert) === null || _theme$palette$dialog2 === void 0 ? void 0 : _theme$palette$dialog2.background,
      "&:hover": {
        backgroundColor: (_theme$palette$dialog3 = theme.palette.dialogues) === null || _theme$palette$dialog3 === void 0 ? void 0 : (_theme$palette$dialog4 = _theme$palette$dialog3.expert) === null || _theme$palette$dialog4 === void 0 ? void 0 : _theme$palette$dialog4.background
      },
      "&:focus": {
        backgroundColor: (_theme$palette$dialog5 = theme.palette.dialogues) === null || _theme$palette$dialog5 === void 0 ? void 0 : (_theme$palette$dialog6 = _theme$palette$dialog5.expert) === null || _theme$palette$dialog6 === void 0 ? void 0 : _theme$palette$dialog6.background
      }
    },
    navItemFont: theme.typography.navItem
  };
};
export default withStyles(styles)(withi18n(NavigtaionItem));
NavigtaionItem.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  link: PropTypes.string,
  selected: PropTypes.bool.isRequired,
  onClickHandle: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  listItemStyles: PropTypes.string
};